import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { TelehealthConsentComponent } from "./telehealth-consent.component";

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Telehealth Consent'
    },
    children: [
      {
        path: '',
        component: TelehealthConsentComponent,
        data: {
          title: 'Home'
        }
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TelehealthConsentRoutingModule { }
